<template lang="pug">
  v-container(fluid).users-page
    portal(to='toolbar')
      v-toolbar-title Users
    v-card
      .body.inner-scroll
        users-filters(
          @filterChanged="loadList"
        )
        list(
          :loading="listLoading"
          :list="list"
          :pagination="pagination"
          :headers="headers"
          :sort-model="sortModel"
          delete-dialog-title="Are you sure to delete this user?"
          sortable
          hide-select
          v-slot="{item}"
          @loadMoreClick="loadListMore"
          @removeClicked="removeUser"
          @itemEditClick="showChangePasswordModal"
          @sortChanged="loadList"
        )
          td.pl-4.w-50 {{ item.id }}
          td(
            @click="openUserDetails(item.id)"
          ).pl-4.w-300.link
            span {{ item.email }}
            span(v-if="item.application_email && item.application_email !== item.email" class="text--secondary")
              |  ({{ item.application_email }})
          td.pl-4 {{ item.application_id || '-' }}
          template(v-if="item.nu_exams_profile")
            td.pl-4 {{ item.nu_exams_profile.first_name }}
            td.pl-4 {{ item.nu_exams_profile.last_name }}
            td.pl-4 {{ item.role || '-' }}
            td.pl-4 {{ item.nu_exams_profile.active_plan }}
            td.pl-4 {{ item.nu_exams_profile.paid_at | formattedDate }}
            td.pl-4 {{ item.nu_exams_profile.expires_in | formattedDate }}
          template(v-else)
            td.pl-4 -
            td.pl-4 -
            td.pl-4 {{ item.role || '-' }}
            td.pl-4 -
            td.pl-4 -
            td.pl-4 -

    chapter-modal-add(
      :value="changeModalOpened"
      :user="selectedUser"
      @closeModal="hidePasswordModal"
    )
</template>

<script>
import ErrorMixin from "@/mixins/errors.mixin"
import {UsersService} from "@/app/exercise/modules/users/core/users-service";
import {UserSortingModel} from "./core/models/UserSortingModel";

export default {
  components: {
    list: () => import('@/app/exercise/components/ItemsList'),
    chapterModalAdd: () => import('@/app/exercise/modules/users/components/ChangePasswordModal'),
    usersFilters: () => import('@/app/exercise/modules/users/components/UsersFilters'),
  },

  data() {
    return {
      svc: null,
      list: [],
      listLoading: false,
      pagination: null,
      selectedUser: null,
      changeModalOpened: false,
      headers: [
        { text: 'ID', align: 'left', class: 'pl-4 w-50', value: 'id'},
        { text: 'Email', align: 'left', class: 'pl-4 w-300', value: 'email'},
        { text: 'Application ID', align: 'left', class: "pl-4", value: 'application_id', sortable: false },
        { text: 'First Name', align: 'left', class: "pl-4", value: 'first_name' },
        { text: 'Last Name', align: 'left', class: "pl-4", value: 'last_name' },
        { text: 'Role', align: 'left', class: "pl-4", value: 'role' },
        { text: 'Active Plan', align: 'left', class: "pl-4", sortable: false},
        { text: 'Paid At', align: 'left', class: "pl-4", value: 'paid_at', sortable: false },
        { text: 'Expires In', align: 'left', class: "pl-4", value: 'expires_in', sortable: false },
        { text: 'Actions', align: 'center', class: "w-100", sortable: false }
      ],
      sortModel: null
    }
  },

  mixins: [ErrorMixin],

  created() {
    this.init()
  },

  async mounted() {
    this.pagination = {
      page: 1
    };

    this.loadList();
  },

  methods: {
    init() {
      this.svc = new UsersService(this.$auth);
      this.sortModel = new UserSortingModel(this.$route.query);
    },

    async loadList() {
      try {
        this.listLoading = true;
        let { results, pagination } = await this.svc.list({
          ...this.$route.query,
          page: 1,
        });
        this.pagination = pagination;
        this.list = results;
        this.listLoading = false;
      } catch (error) {
        this.listLoading = false;
        this.processError(error, {redirectName: this.$ROUTER_NAMES.LOGIN_EXERCISE});
      }
    },

    async loadListMore(page) {
      try {
        this.listLoading = true;
        let { results } = await this.svc.list({
          page
        });
        this.list.push(...results);
        this.listLoading = false;
      } catch (error) {
        this.listLoading = false;
        this.processError(error, {redirectName: this.$ROUTER_NAMES.LOGIN_EXERCISE});
      }
    },

    openUserDetails(id) {
      this.$router.push({ name: this.$ROUTER_NAMES.USER_DETAILS, params: { id } });
    },

    async removeUser(user) {
      try {
        this.listLoading = true;
        await this.svc.remove(user);
        this.loadList();
      } catch (e) {
        this.listLoading = false;
      }
    },

    showChangePasswordModal(item) {
      this.changeModalOpened = true;
      this.selectedUser = item;
    },

    hidePasswordModal() {
      this.selectedUser = null;
      this.changeModalOpened = false;
    }
  }
}
</script>

<style lang="scss" scoped>
  .users-page::v-deep {
    .w-100 {
      width: 100px;
    }
    .w-300 {
      width: 300px;
    }
    .w-50 {
      width: 50px;
    }
    .v-card {
      .body {
        height: 100vh;
        max-height: calc(100vh - 90px);
        overflow: auto;
        &.inner-scroll {
          overflow: hidden;
          display: flex;
          flex-direction: column;
        }
      }
    }
  }
</style>

